import { useState } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { getPostAuthRedirect } from '../utils/authNavigation'
import './LoginForm.css'

function LoginForm({ onSwitchToSignup }) {
  const { login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)

    try {
      const result = await login(email, password)
      if (!result.success) {
        setError(result.error || 'Login failed')
      } else {
        // If successful, redirect to intended destination or dashboard
        navigate(getPostAuthRedirect(location), { replace: true })
      }
    } catch (err) {
      setError(err.message || 'An unexpected error occurred')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      {error && (
        <div className="auth-error">
          {error}
        </div>
      )}

      <div className="form-group">
        <label htmlFor="login-email">Email or Username</label>
        <input
          type="text"
          id="login-email"
          name="email"
          placeholder="your@email.com or username"
          className="form-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label htmlFor="login-password">Password</label>
        <input
          type="password"
          id="login-password"
          name="password"
          placeholder="••••••••"
          className="form-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={isLoading}
        />
      </div>

      <button
        type="submit"
        className="auth-submit-btn"
        disabled={isLoading}
      >
        {isLoading ? 'Signing In...' : 'Sign In'}
      </button>

      <p style={{ textAlign: 'center', marginTop: '0.75rem', marginBottom: 0 }}>
        <Link to="/forgot-password" style={{ color: 'var(--accent)', fontSize: '0.9rem' }}>
          Forgot password?
        </Link>
      </p>

      <div className="auth-divider">
        <span>or</span>
      </div>

      <button
        type="button"
        className="auth-secondary-btn"
        onClick={onSwitchToSignup}
        disabled={isLoading}
      >
        Create Account
      </button>
    </form>
  )
}

export default LoginForm
